import { IncorporationDocTooltip } from '../PracticeProfileTooltips'

import { UploadItem } from './UploadItem'
import { Text } from '@/ui'
import { UploadDocumentType } from '@/constants/businessConstants'

import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

export const FormIncorporationDocumentUploadItem = ({
  businessEntity,
  uploadButtonOnly,
}: {
  businessEntity?: string
  uploadButtonOnly?: boolean
}) => {
  return (
    <UploadItem
      label="Incorporation Document"
      popUpContent={<IncorporationDocTooltip />}
      documentCategory={UserDocumentCategoryIdentifier.businessIncorporation}
      documentType={UploadDocumentType.INCORPORATION}
      additionalTrackingProperties={{
        document_category: 'incorporation_document',
        business_entity: businessEntity,
      }}
      uploadButtonOnly={uploadButtonOnly}
    >
      <Text>
        Articles of incorporation are formal documents filed with a governmental
        body to legally establish a corporation. They typically contain relevant
        information such as the corporation&apos;s name, street address, agent
        for service of process, and the quantity and type of stock to be issued.
      </Text>
    </UploadItem>
  )
}
